export function dismissalKey(slug: string, key: string): string {
  return `mealplan:${slug}:${key}`;
}
